import React from "react";
import propic from "../assets/profile.jpg";

const About = () => {
  return (
    <section
      id="about"
      className="py-24 bg-gradient-to-b to-gray-900 from-black px-6 md:px-24"
    >
      <div className="container mx-auto flex flex-col md:flex-row md:items-start items-center justify-center">
        {/* Profile Image */}
        <div className="flex justify-center md:justify-start mb-8 md:mb-0">
          <img
            src={propic}
            alt="Profile"
            className="rounded-full w-48 h-48 md:w-64 md:h-64 border-4 border-yellow-400 shadow-lg transition-transform transform hover:scale-105"
          />
        </div>

        {/* About Text */}
        <div className="text-center md:text-left md:ml-12 w-full md:w-2/3">
          <h2 className="text-5xl md:text-6xl font-bold text-yellow-400 mb-6">
            About Me
          </h2>
          <p className="text-gray-400 text-lg leading-relaxed mb-8">
            I am a passionate and driven software developer with a strong
            background in React, Node.js, and MongoDB. I have experience working
            on diverse projects, including a comprehensive pet management system
            (PetLife) that features pet care management, vaccination records,
            appointment booking, and an e-commerce section. My expertise also
            extends to building responsive, modern UIs using Tailwind CSS and
            professional design principles. I thrive on solving complex problems
            and developing meaningful solutions that drive innovation. My work
            includes real-time applications like chat systems, ticket pools, and
            video players, where performance and user experience are key
            priorities. I am skilled in integrating Google login, WebSockets,
            and email notifications to enhance functionality and user
            engagement. I am committed to continuous learning, often exploring
            new technologies and participating in coding challenges to sharpen
            my skills. I enjoy working both independently and collaboratively,
            consistently delivering high-quality work with a focus on modern,
            professional design.
          </p>

          {/* Education Section */}
          <div>
            <h3 className="text-4xl font-bold text-yellow-400 mb-4">
              Education
            </h3>
            <div className="overflow-x-auto bg-gray-800 rounded-lg shadow-lg">
              <table className="min-w-full table-auto">
                <thead>
                  <tr className="text-left text-yellow-400">
                    <th className="px-6 py-3 text-sm font-semibold">
                      Institution
                    </th>
                    <th className="px-6 py-3 text-sm font-semibold">
                      Qualification
                    </th>
                    <th className="px-6 py-3 text-sm font-semibold">Year</th>
                    <th className="px-6 py-3 text-sm font-semibold">
                      Result/Pass
                    </th>{" "}
                    {/* New column */}
                  </tr>
                </thead>
                <tbody className="text-gray-400">
                  <tr>
                    <td className="px-6 py-4">
                      Informatics Institute of Technology (IIT)
                    </td>
                    <td className="px-6 py-4">BSc (Hons) Computer Science</td>
                    <td className="px-6 py-4">2024 - present</td>
                    <td className="px-6 py-4">Ongoing</td>{" "}
                    {/* Result for this row */}
                  </tr>
                  <tr>
                    <td className="px-6 py-4">
                      Informatics Institute of Technology (IIT)
                    </td>
                    <td className="px-6 py-4">
                      Foundation Certificate in Higher Education
                    </td>
                    <td className="px-6 py-4">2023 - 2024</td>
                    <td className="px-6 py-4">Distinction</td>{" "}
                    {/* Result for this row */}
                  </tr>
                  <tr>
                    <td className="px-6 py-4">Rahula College Matara</td>
                    <td className="px-6 py-4">
                      G.C.E. Advance Level - Physical Science Stream
                    </td>
                    <td className="px-6 py-4">2019 - 2022 (2023)</td>
                    <td className="px-6 py-4">B pass & two C passes</td>{" "}
                    {/* Result for this row */}
                  </tr>
                  <tr>
                    <td className="px-6 py-4">Rahula College Matara</td>
                    <td className="px-6 py-4">G.C.E. Ordinary Level</td>
                    <td className="px-6 py-4">2017 - 2019</td>
                    <td className="px-6 py-4">8 A's & 1 B</td>{" "}
                    {/* Result for this row */}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
